// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"61":"browser-tip","594":"about"}[chunkId] + ".1778132311715.js";
};